import { KYMW1308Component } from './kymw1308.component';
import { isArray } from '@grapecity/wijmo';
import { PlessViewUtilsSub } from '../../../../../src/app/commons/kymw00/pless-view-utils-sub.service';
import { KYMW1308PromotionGoodsInfoModel } from './vo/kymw1308-promotion-goods-info.model';
import * as wjcCore from '@grapecity/wijmo';
/**
 * バンドルミックスマッチ画面の値を管理するクラス
 *
 * @export KYMW1308Model
 * @class KYMW1308Model
 */
export class KYMW1308Model {
  KYMW1308Component: KYMW1308Component;
  private readonly FLAG_ON: string = '1';
  private readonly DIV_BUNDLE: string = 'B';
  private readonly DIV_MIX: string = 'P';
  private readonly DIV_POINT: string = 'T';
  // プロモーションＮＯリスト
  public promotionNoList: Array<string> = new Array<string>();
  // プロモーションＮＯ
  public promotionNo: string = <string>'';
  // プロモーション名称
  public promotionName: string = <string>'';
  // プロモーション区分
  public promotionDiv: string = <string>'';
  // 設定単位
  public setUnit: string = <string>'';
  // 生協選択　いばらき
  public coopIB: boolean = <boolean>false;
  // 生協選択　とちぎ
  public coopTO: boolean = <boolean>false;
  // 生協選択　ぐんま
  public coopGU: boolean = <boolean>false;
  // 生協選択　ちば
  public coopTI: boolean = <boolean>false;
  // 生協選択　さいたま
  public coopSA: boolean = <boolean>false;
  // 生協選択　とうきょう
  public coopTK: boolean = <boolean>false;
  // 生協選択　ながの
  public coopNA: boolean = <boolean>false;
  // 生協選択　にいがた
  public coopNI: boolean = <boolean>false;
  // 生協選択　クルコ
  public coopKU: boolean = <boolean>false;
  // 成立数量
  public approvedNum: string = <string>'';
  // 成立価格
  public approvedPrice: string = <string>'';
  // わくわくポイント
  public wakuwakuPoint: string = <string>'';
  // 値引率
  public discountPercent: string = <string>'';
  // 一括反映対象
  public reflectionTarget: string = <string>'';
  // プロモーション情報
  public promotionInfo: Array<any> = [];
  // 編集ロック
  public editLock: boolean = <boolean>false;
  public editLockBtn: boolean = <boolean>false;
  // 受注コード
  public orderCode: string = <string>'';
  // 媒体区分
  public mediumType: string = <string>'';
  // 検索時プロモーション区分
  public accessPromotionDiv: string = <string>'';
  // 検索時プロモーション名称
  public accessPromotionName: string = <string>'';
  // 検索時生協コード
  public accessCoopCode: string = <string>'';
  // 検索時Ｐコード
  public accessPCode: string = <string>'';
  // 検索時部門コード
  public accessClassCode: string = <string>'';
  // 編集可否 プロモーション名称
  public disabledPromotionName: boolean = <boolean>false;
  // 編集可否 行削除
  public disabledDelRow: boolean = <boolean>false;
  // 編集可否 全削除
  public disabledDelAll: boolean = <boolean>false;
  // 編集可否 設定
  public disabledRegist: boolean = <boolean>false;
  // 編集可否 区分 バンドル
  public disabledBundle: boolean = <boolean>false;
  // 編集可否 区分 ミックスマッチ
  public disabledMix: boolean = <boolean>false;
  // 編集可否 区分 ポイント
  public disabledPoint: boolean = <boolean>false;
  // 編集可否 設定単位 全生協
  public disabledUnitAll: boolean = <boolean>false;
  // 編集可否 設定単位 生協単位
  public disabledUnitCoop: boolean = <boolean>false;
  // 編集可否 生協
  public disabledSelectCoop: boolean = <boolean>false;
  // 編集可否 生協 いばらき
  public disabledCoopIB: boolean = <boolean>false;
  // 編集可否 生協 とちぎ
  public disabledCoopTO: boolean = <boolean>false;
  // 編集可否 生協 ぐんま
  public disabledCoopGU: boolean = <boolean>false;
  // 編集可否 生協 ちば
  public disabledCoopTI: boolean = <boolean>false;
  // 編集可否 生協 さいたま
  public disabledCoopSA: boolean = <boolean>false;
  // 編集可否 生協 とうきょう
  public disabledCoopTK: boolean = <boolean>false;
  // 編集可否 生協 ながの
  public disabledCoopNA: boolean = <boolean>false;
  // 編集可否 生協 にいがた
  public disabledCoopNI: boolean = <boolean>false;
  // 編集可否 生協 クルコ
  public disabledCoopKU: boolean = <boolean>false;
  // 編集可否 一括反映
  public disabledReflection: boolean = <boolean>false;
  // 編集可否 成立数量
  public disabledApprovedNum: boolean = <boolean>false;
  // 編集可否 成立価格
  public disabledApprovedPrice: boolean = <boolean>false;
  // 編集可否 値引率
  public disabledDiscountPercent: boolean = <boolean>false;
  // 編集可否 わくわくポイント
  public disabledWakuwakuPoint: boolean = <boolean>false;
  // 編集可否 全商品
  public disabledTargetAll: boolean = <boolean>false;
  // 編集可否 選択商品
  public disabledTargetGoods: boolean = <boolean>false;
  // ソート情報
  public sortDirection: any = null;
  /**
   * サーバから取得したプロモーションＮＯを反映する
   *
   * @param serverData サーバ取得データ
   */
  public updatePromotionNo(serverData: any): void {
    this.promotionNoList = [];
    this.promotionNoList.push('');
    this.promotionNo = '';
    if (serverData == null) {
      return; 
    }
    if (isArray(serverData)) {
      for ( let i = 0; i < serverData.length; i++ ) {
        this.promotionNoList.push(serverData[i].PromotionNo);
      }
    } else {
      this.promotionNoList.push(serverData.PromotionNo);
    }
    // 価格パターン連動マーク一覧更新
    this.KYMW1308Component.updatePromotionGoodsInfo();
  }
  /**
   * サーバから取得したプロモーション情報を反映する
   *
   * @param serverData サーバ取得データ
   */
  public updatePromotionInfo (serverData: any ): void {
    this.promotionInfo = [];
    if ( serverData == null ) {
      return; 
    }
    let promotionGoodsInfo: Array<any> = [];
    const pCodeList: Array<string> = [];
    if (isArray(serverData)) {
      promotionGoodsInfo = serverData;
    } else {
      promotionGoodsInfo.push(serverData);
    }
    this.promotionName = PlessViewUtilsSub.nullToBlank(promotionGoodsInfo[0].PromotionName);
    this.promotionDiv = promotionGoodsInfo[0].PromotionDiv;
    for (const promotionGoodsData of promotionGoodsInfo) {
      pCodeList.push(promotionGoodsData.PCode);
      this.promotionInfo.push(this.getPromotionGoodsInfoVO(promotionGoodsData));
    }
    // 排他ロック
    if (this.editLockBtn) {
      this.KYMW1308Component.LockUtilForPlanGoods('REGIST', this.orderCode, this.mediumType, pCodeList,
                                                  (event: any) => {
                                                    this.KYMW1308Component.lockScc_Handler(event); 
                                                  }, null,
                                                  (event: any, result: any) => {
                                                    this.KYMW1308Component.lockErr_Handler(event, result); 
                                                  }, null, false );
    }
  }
  /* プロモーション情報一覧を作成 */
  private getPromotionGoodsInfoVO(data: any): KYMW1308PromotionGoodsInfoModel {
    const vo: KYMW1308PromotionGoodsInfoModel = new KYMW1308PromotionGoodsInfoModel();
    // Ｐコード
    vo.pCode = data.PCode;
    // 商品案内用商品名
    vo.guideGoodsName = data.GuideGoodsName;
    // 商品案内用規格名
    vo.guideStandardName = data.GuideStandardName;
    // 取扱フラグ（いばらき）
    if ( data.HandlingFlgIB === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgIB = data.HandlingFlgIB;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceIB = data.ThisTimeSupplyPriceIB;
      // 仕入価格
      vo.thisTimeCostPriceIB = Number(data.ThisTimeCostPriceIB).toFixed(2);
      // プロモーションフラグ（いばらき）
      if ( this.getDataValue(data.PromotionFlgIB) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumIB = data.ApprovedNumIB;
          // 成立価格
          vo.approvedPriceIB = data.ApprovedPriceIB;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointIB = data.WakuwakuPointIB;
        }
      }
    }
    // 取扱フラグ（とちぎ）
    if ( data.HandlingFlgTO === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgTO = data.HandlingFlgTO;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTO = data.ThisTimeSupplyPriceTO;
      // 仕入価格
      vo.thisTimeCostPriceTO = Number(data.ThisTimeCostPriceTO).toFixed(2);
      // プロモーションフラグ（とちぎ）
      if ( this.getDataValue(data.PromotionFlgTO) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumTO = data.ApprovedNumTO;
          // 成立価格
          vo.approvedPriceTO = data.ApprovedPriceTO;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointTO = data.WakuwakuPointTO;
        }
      }
    }
    // 取扱フラグ（ぐんま）
    if ( data.HandlingFlgGU === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgGU = data.HandlingFlgGU;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceGU = data.ThisTimeSupplyPriceGU;
      // 仕入価格
      vo.thisTimeCostPriceGU = Number(data.ThisTimeCostPriceGU).toFixed(2);
      // プロモーションフラグ（ぐんま）
      if (this.getDataValue( data.PromotionFlgGU) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumGU = data.ApprovedNumGU;
          // 成立価格
          vo.approvedPriceGU = data.ApprovedPriceGU;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointGU = data.WakuwakuPointGU;
        }
      }
    }
    // 取扱フラグ（ちば）
    if ( data.HandlingFlgTI === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgTI = data.HandlingFlgTI;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTI = data.ThisTimeSupplyPriceTI;
      // 仕入価格
      vo.thisTimeCostPriceTI = Number(data.ThisTimeCostPriceTI).toFixed(2);
      // プロモーションフラグ（ちば）
      if ( this.getDataValue(data.PromotionFlgTI) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumTI = data.ApprovedNumTI;
          // 成立価格
          vo.approvedPriceTI = data.ApprovedPriceTI;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointTI = data.WakuwakuPointTI;
        }
      }
    }
    // 取扱フラグ（さいたま）
    if ( data.HandlingFlgSA === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgSA = data.HandlingFlgSA;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceSA = data.ThisTimeSupplyPriceSA;
      // 仕入価格
      vo.thisTimeCostPriceSA = Number(data.ThisTimeCostPriceSA).toFixed(2);
      // プロモーションフラグ（さいたま）
      if ( this.getDataValue(data.PromotionFlgSA) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumSA = data.ApprovedNumSA;
          // 成立価格
          vo.approvedPriceSA = data.ApprovedPriceSA;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointSA = data.WakuwakuPointSA;
        }
      }
    }
    // 取扱フラグ（とうきょう）
    if ( data.HandlingFlgTK === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgTK = data.HandlingFlgTK;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTK = data.ThisTimeSupplyPriceTK;
      // 仕入価格
      vo.thisTimeCostPriceTK = Number(data.ThisTimeCostPriceTK).toFixed(2);
      // プロモーションフラグ（とうきょう）
      if ( this.getDataValue(data.PromotionFlgTK) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumTK = data.ApprovedNumTK;
          // 成立価格
          vo.approvedPriceTK = data.ApprovedPriceTK;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointTK = data.WakuwakuPointTK;
        }
      }
    }
    // 取扱フラグ（ながの）
    if ( data.HandlingFlgNA === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgNA = data.HandlingFlgNA;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNA = data.ThisTimeSupplyPriceNA;
      // 仕入価格
      vo.thisTimeCostPriceNA = Number(data.ThisTimeCostPriceNA).toFixed(2);
      // プロモーションフラグ（ながの）
      if ( this.getDataValue(data.PromotionFlgNA) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumNA = data.ApprovedNumNA;
          // 成立価格
          vo.approvedPriceNA = data.ApprovedPriceNA;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointNA = data.WakuwakuPointNA;
        }
      }
    }
    // 取扱フラグ（にいがた）
    if ( data.HandlingFlgNI === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgNI = data.HandlingFlgNI;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNI = data.ThisTimeSupplyPriceNI;
      // 仕入価格
      vo.thisTimeCostPriceNI = Number(data.ThisTimeCostPriceNI).toFixed(2);
      // プロモーションフラグ（にいがた）
      if ( this.getDataValue(data.PromotionFlgNI) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumNI = data.ApprovedNumNI;
          // 成立価格
          vo.approvedPriceNI = data.ApprovedPriceNI;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointNI = data.WakuwakuPointNI;
        }
      }
    }
    // 取扱フラグ（クルコ）
    if ( data.HandlingFlgKU === this.FLAG_ON ) {
      // 取扱フラグ
      vo.handlingFlgKU = data.HandlingFlgKU;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceKU = data.ThisTimeSupplyPriceKU;
      // 仕入価格
      vo.thisTimeCostPriceKU = Number(data.ThisTimeCostPriceKU).toFixed(2);
      // プロモーションフラグ（クルコ）
      if ( this.getDataValue(data.PromotionFlgKU) === this.FLAG_ON ) {
        if ( this.promotionDiv === this.DIV_BUNDLE ||
            this.promotionDiv === this.DIV_MIX ) {
          // 成立数量
          vo.approvedNumKU = data.ApprovedNumKU;
          // 成立価格
          vo.approvedPriceKU = data.ApprovedPriceKU;
        } else if ( this.promotionDiv === this.DIV_POINT ) {
          // わくわくポイント
          vo.wakuwakuPointKU = data.WakuwakuPointKU;
        }
      }
    }
    return vo;
  }
  /**
   * サーバから取得した成立価格を反映する
   *
   * @param serverData サーバ取得データ
   */
  public updateApprovedPrice (serverData: any): void {
    if ( serverData == null || !isArray(serverData)) {
      return;
    }
    for (const obj of serverData) {
      for (const promotionGoodsInfoVO of this.promotionInfo ) {
        if ( obj.PCode === promotionGoodsInfoVO.pCode ) {
          if ( obj.ApprovedPriceIB > 0 ) {
            promotionGoodsInfoVO.approvedPriceIB = obj.ApprovedPriceIB; 
          }
          if ( obj.ApprovedPriceTO > 0 ) {
            promotionGoodsInfoVO.approvedPriceTO = obj.ApprovedPriceTO; 
          }
          if ( obj.ApprovedPriceGU > 0 ) {
            promotionGoodsInfoVO.approvedPriceGU = obj.ApprovedPriceGU; 
          }
          if ( obj.ApprovedPriceTI > 0 ) {
            promotionGoodsInfoVO.approvedPriceTI = obj.ApprovedPriceTI; 
          }
          if ( obj.ApprovedPriceSA > 0 ) {
            promotionGoodsInfoVO.approvedPriceSA = obj.ApprovedPriceSA; 
          }
          if ( obj.ApprovedPriceTK > 0 ) {
            promotionGoodsInfoVO.approvedPriceTK = obj.ApprovedPriceTK; 
          }
          if ( obj.ApprovedPriceNA > 0 ) {
            promotionGoodsInfoVO.approvedPriceNA = obj.ApprovedPriceNA; 
          }
          if ( obj.ApprovedPriceNI > 0 ) {
            promotionGoodsInfoVO.approvedPriceNI = obj.ApprovedPriceNI; 
          }
          if ( obj.ApprovedPriceKU > 0 ) {
            promotionGoodsInfoVO.approvedPriceKU = obj.ApprovedPriceKU; 
          }
          break;
        }
      }
    }
    if ( this.reflectionTarget === '1') {
      this.KYMW1308Component.reflectPromotion( this.approvedNum, '', '' );
    } else {
      this.KYMW1308Component.reflectRow( this.KYMW1308Component.dtg_PromotionInfo.selection.row, this.approvedNum, '', '' );
    }
    // グリッド再描画
    this.KYMW1308Component.dtg_PromotionInfo.refresh(false);
  }
  /**
   * サーバから取得した企画商品情報を反映する
   *
   * @param serverData サーバ取得データ
   */
  public updatePlanGoodsInfo( serverData: any ): void {
    if ( serverData == null ) {
      return; 
    }
    let planGoodsInfo: Array<any> = new Array<any>();
    const pCodeList: Array<any> = new Array<any>();
    if ( isArray(serverData) ) {
      planGoodsInfo = serverData;
    } else {
      planGoodsInfo.push(serverData);
    }
    for ( const planGoodsData of planGoodsInfo ) {
      if ( planGoodsData.PromotionFlg === '1' ) {
        this.KYMW1308Component.dialogService.openAlertGetMessage('E0167', [planGoodsData.PCode, planGoodsData.GuideGoodsName], null);
        continue;
      }
      pCodeList.push( planGoodsData.PCode );
      this.promotionInfo = this.promotionInfo.concat( this.getPromotionGoodsInfoVO( planGoodsData ) );
    }
    // 排他ロック
    if ( this.editLockBtn ) {
      this.KYMW1308Component.LockUtilForPlanGoods('REGIST', this.orderCode, this.mediumType, pCodeList,
                                                  (event: any) => {
                                                    this.KYMW1308Component.lockScc_Handler(event); 
                                                  }, null,
                                                  (event: any , result: any) => {
                                                    this.KYMW1308Component.lockErr_Handler(event , result); 
                                                  }, null, false);
    }
    setTimeout(() => {
      this.KYMW1308Component.dtg_PromotionInfo.collectionView.sortDescriptions.clear();
      for (let i = 0; i < this.sortDirection.length; i++) {
        const sortDesc = this.sortDirection[i];
        this.KYMW1308Component.dtg_PromotionInfo.collectionView.sortDescriptions.push(
          new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
        );
      }
    });
  }
  /**
   * null/配列を考慮してデータの値を取得する
   *
   * @private
   * @param {*} data
   * @returns {string}
   * @memberof KYMW1312Model
   */
  private getDataValue(data: any): string {
    let result: string = null;
    if (data == null) {
      result = null;
    } else if (isArray(data)) {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        result = null;
      } else {
        result = data[0];
      }
    } else {
      result = data;
    }
    return result;
  }
}
